import React from "react";
import Icon from "../Icon";
import Typo from "../Typo";

const Tab = React.forwardRef(
  (
    {
      className,
      style,
      selected,
      icon,
      symbol,
      iconProps,
      label,
      value,
      children,
      onClick,
      disabled,
      ...rest
    },
    ref,
  ) => {
    const classes = [
      "ta-tab",
      selected ? "ta-is-selected" : "",
      disabled ? "ta-is-disabled" : "",
      className,
    ]
      .filter(Boolean)
      .join(" ");

    const action = (e) => {
      if (onClick && !disabled) onClick(e);
    };

    return (
      <button
        ref={ref}
        className={classes}
        style={style}
        role="tab"
        aria-selected={selected || undefined}
        disabled={disabled}
        onClick={action}
        {...rest}
      >
        <div className="ta-tab_state-layer"></div>
        <div className="ta-tab_content">
          {(icon || symbol) && (
            <Icon
              symbol={symbol || icon}
              {...iconProps}
              className="ta-tab_icon"
            />
          )}
          {(label || children) && (
            <Typo type="title" size="s" className="ta-tab_label">
              {label || children}
            </Typo>
          )}
        </div>
        <div className="ta-tab_indicator"></div>
      </button>
    );
  },
);

export default Tab;
